import { assignInlineVars } from '@vanilla-extract/dynamic';
import { clsx } from 'clsx';
import React from 'react';
import { spinner, spinnerColorVar } from './Spinner.css';

interface SpinnerProps extends Omit<React.HTMLProps<HTMLDivElement>, 'size'> {
  readonly color?: string;
  readonly size?: 'md' | 'sm';
  readonly disabled?: boolean;
}

export const Spinner: React.FC<SpinnerProps> = ({
  color,
  disabled,
  size = 'md',
  className: externalClassName,
  ...props
}) => {
  const colorOverride = color != null ? assignInlineVars({ [spinnerColorVar]: color }) : undefined;
  return (
    <div
      {...props}
      aria-busy="true"
      className={clsx(spinner({ size, disabled }), externalClassName)}
      role="progressbar"
      style={{ ...props.style, ...colorOverride }}
    />
  );
};
